import { dateOnly } from 'utils/dateSchemas';
import z from 'zod';

export const ScheduleEntitySchema = z.object({
    id: z.string(),
    date: dateOnly(),
});

export type ScheduleEntity = z.infer<typeof ScheduleEntitySchema>;
